import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalComponent} from 'app/core/modal.component';
import {ToolbarItem} from '../../../entities/toolbarItem';
import {NavigationService} from '../../../services/navigation.service';
import {UserModelService} from '../../../models/user-model.service';

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-drop-down-menu',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class DropDownMenuComponent extends ModalComponent implements OnInit {
  value: string;
  pressed = false;
  subMenu = [];

  constructor(
    modalController: ModalController,
    private navigationService: NavigationService,
    private userModelService: UserModelService,
  ) {
    super(modalController);
  }

  ngOnInit() {}

  clickOnItem(item) {
    this.closeModal();
    if (typeof item.link === 'string') {
      this.navigationService.goTo(item.link);
    } else {
      item.link();
    }
  }

  isMenuActive(item: ToolbarItem) {
    if (item.subMenu?.length) {
      return item.subMenu.some((i) => this.navigationService.isCurrentUrl(i.link));
    } else {
      return this.navigationService.isCurrentUrl(item.link);
    }
  }

  isPermissionOK(item: ToolbarItem) {
    if (item.permission) {
      return this.userModelService.isLogin() && this.userModelService.permissions.checkPermission(item.permission);
    }

    return true;
  }

  closeModal() {
    return super.closeModal({answer: 'answer'});
  }
}
